<template>
  <div class="head_product_module">
    <div v-for="(pItem,index) in proModule" :key="index" class="proM_item" @click="headProLink(index)">
      <span>{{pItem.name}}</span>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../../../common/util/eventBus.js';
export default {
  data() {
    return {
      proModule: [{ name: ' Products' }, { name: 'Technical' }]
    };
  },
  methods: {
    headProLink(param) {
      this.proBusNoTrans(param);
      this.proRouterTrans(param);
    },
    proBusNoTrans(numbers) {
      eventBus.$emit('enProMdulePlayer', numbers);
    },
    proRouterTrans(numbers) {
      this.$router.push({
        name: 'iaic2019en/product',
        params: {
          proType: numbers
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.head_product_module {
  background-color: #F1F3F4;
  width: 100px;

  .proM_item {
    font-size: 16px;
    width: 100px;
    line-height: 35px;
    height: 35px;
    text-align: center;
    padding: 5px 0;
  }

  .proM_item:hover {
    background-color: #00697F;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/header/product.vue